var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalFirstAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27746 14.8226L4.06429 18.804C3.87523 19.1441 4.12741 19.5658 4.50474 19.5405L6.7138 19.3925C6.90452 19.3798 7.08393 19.4873 7.16864 19.6653L8.14979 21.7262C8.31738 22.0783 8.79509 22.0942 8.98415 21.7541L11.499 17.2301C9.46621 17.1159 7.63403 16.2182 6.27746 14.8226Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.497 17.2229L15.0159 21.7541C15.2049 22.0942 15.6826 22.0783 15.8502 21.7262L16.8314 19.6653C16.9161 19.4873 17.0955 19.3798 17.2862 19.3925L19.4953 19.5405C19.8726 19.5658 20.1248 19.1441 19.9357 18.804L17.6791 14.7446C16.3406 16.1581 14.5216 17.0793 12.497 17.2229Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9408 15.7674C15.6013 15.7674 18.5686 12.6855 18.5686 8.88371C18.5686 5.08194 15.6013 2 11.9408 2C8.2804 2 5.31303 5.08194 5.31303 8.88371C5.31303 12.6855 8.2804 15.7674 11.9408 15.7674ZM13.3222 12.0682C13.3222 12.5925 12.9894 12.9383 12.4956 12.9383C12.0019 12.9383 11.6634 12.5925 11.6634 12.0682V6.11602H11.6302L10.4596 6.96303C10.3042 7.07828 10.1877 7.11861 10.0157 7.11861C9.67732 7.11861 9.42767 6.86508 9.42767 6.49631C9.42767 6.23126 9.52753 6.03535 9.78827 5.8452L11.375 4.70432C11.7633 4.42774 12.0296 4.37588 12.3736 4.37588C12.9672 4.37588 13.3222 4.75041 13.3222 5.34966V12.0682Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalFirstAlt);
export default __webpack_public_path__ + "static/media/medal-first-alt.aff34ddd62e1d1b81c6c26aa83fd1af6.svg";
export { ForwardRef as ReactComponent };